import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface State {
  hasChanged: boolean;
  value: string;
}

const initialState: State = {
  hasChanged: false,
  value: "",
};

const gitShaSlice = createSlice({
  name: "gitSha",
  initialState,
  reducers: {
    setGitSha: (state, action: PayloadAction<string | null | undefined>) => {
      const newVersion = action.payload;
      if (!newVersion) return;

      if (!state.value) {
        state.value = newVersion;
        return;
      }

      if (state.value === newVersion) return;

      state.hasChanged = true;
    },
  },
});

export const { setGitSha } = gitShaSlice.actions;
export const { reducer } = gitShaSlice;
